import { G_TO_METER_PER_SEC_SQUARED } from './analytics-lib/constants';
import { copyArray2D } from './util/deepCopy';
var ObcFrame = (function () {
    function ObcFrame(obj) {
        if (obj === void 0) { obj = null; }
        this.timestamp = 0;
        this.readings = Array(ObcFrame.NUM_SENSORS).fill([1, 0, 0, 0]);
        this.accelerations = undefined;
        this.angularVelocities = undefined;
        if (obj) {
            this.timestamp = obj.timestamp;
            this.readings = copyArray2D(obj.readings);
            if (obj.accelerations) {
                this.accelerations = copyArray2D(obj.accelerations);
            }
            if (obj.angularVelocities) {
                this.angularVelocities = copyArray2D(obj.angularVelocities);
            }
        }
    }
    ObcFrame.prototype.clone = function () {
        var frame = new ObcFrame();
        frame.timestamp = this.timestamp;
        frame.readings = copyArray2D(this.readings);
        if (this.accelerations) {
            frame.accelerations = copyArray2D(this.accelerations);
        }
        if (this.angularVelocities) {
            frame.angularVelocities = copyArray2D(this.angularVelocities);
        }
        return frame;
    };
    ObcFrame.prototype.parse = function (buffer) {
        var data = new DataView(buffer);
        var bufferPos = 0;
        this.timestamp = data.getBigUint64 ?
            Number(data.getBigUint64(bufferPos, true)) :
            this.getUint64(data, bufferPos, true);
        bufferPos += 8;
        for (var i = 0; i < ObcFrame.NUM_SENSORS; ++i) {
            this.readings[i] = [
                data.getInt16(bufferPos, true) / 16384,
                data.getInt16(bufferPos + 2, true) / 16384,
                data.getInt16(bufferPos + 4, true) / 16384,
                data.getInt16(bufferPos + 6, true) / 16384,
            ];
            bufferPos += 8;
        }
        if (data.byteLength > bufferPos) {
            this.accelerations = Array(ObcFrame.NUM_SENSORS).fill([0, 0, 0]);
            this.angularVelocities = Array(ObcFrame.NUM_SENSORS).fill([0, 0, 0]);
            for (var i = 0; i < ObcFrame.NUM_SENSORS; ++i) {
                this.accelerations[i] = [
                    (data.getInt16(bufferPos, true) / 4096) * G_TO_METER_PER_SEC_SQUARED,
                    (data.getInt16(bufferPos + 2, true) / 4096) * G_TO_METER_PER_SEC_SQUARED,
                    (data.getInt16(bufferPos + 4, true) / 4096) * G_TO_METER_PER_SEC_SQUARED,
                ];
                bufferPos += 6;
            }
            for (var i = 0; i < ObcFrame.NUM_SENSORS; ++i) {
                this.angularVelocities[i] = [
                    data.getInt16(bufferPos, true) / 16.384,
                    data.getInt16(bufferPos + 2, true) / 16.384,
                    data.getInt16(bufferPos + 4, true) / 16.384,
                ];
                bufferPos += 6;
            }
        }
    };
    ObcFrame.prototype.getUint64 = function (dataView, byteOffset, littleEndian) {
        var left = dataView.getUint32(byteOffset, littleEndian);
        var right = dataView.getUint32(byteOffset + 4, littleEndian);
        var combined = littleEndian ? left + Math.pow(2, 32) * right : Math.pow(2, 32) * left + right;
        if (!Number.isSafeInteger(combined)) {
            console.warn(combined, 'exceeds MAX_SAFE_INTEGER. Precision may be lost');
        }
        return combined;
    };
    ObcFrame.NUM_SENSORS = 5;
    return ObcFrame;
}());
export { ObcFrame };
//# sourceMappingURL=obc-frame.js.map